export default {
    url: '/role',
    template: '<user-group-add-role role="vm.role"/>',
    controller (ClassifierResource, CLASSIFIER_ENUM) {
        this.role = new ClassifierResource({ type: CLASSIFIER_ENUM.KEYS.ROLE });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/add/role/index.js